module.exports = __webpack_public_path__ + "img/72ced2f.png";